import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { defineMessages } from 'react-intl-next';
export var EditTimeMessages = /*#__PURE__*/function (EditTimeMessages) {
  EditTimeMessages["TimePlaceholder"] = "TimePlaceholder";
  return EditTimeMessages;
}({});
export var IntlEditTimeMessages = defineMessages(_defineProperty({}, EditTimeMessages.TimePlaceholder, {
  id: 'form-system.TimeQuestion.TimePlaceholder',
  defaultMessage: 'e.g. {time}'
}));